import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';

const HolidayDialog = ({
  visible,
  onHide,
  holidayForm,
  setHolidayForm,
  handleSaveHoliday,
  loading
}) => {
  return (
    <Dialog 
      header="Set Holiday" 
      visible={visible} 
      onHide={onHide} 
      style={{ width: '500px' }} 
      footer={(
        <div className="flex justify-between items-center mt-4">
          <Button 
            label="Cancel" 
            icon="pi pi-times" 
            onClick={onHide} 
            disabled={loading} 
            className="p-button-text text-gray-600 rounded-lg px-4 py-2" 
          />
          <Button 
            label={loading ? 'Saving...' : 'Set Holiday'} 
            icon="pi pi-check" 
            onClick={handleSaveHoliday} 
            loading={loading} 
            className="bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-lg px-4 py-2 shadow-md hover:shadow-lg transition-all" 
          />
        </div>
      )}
      className="p-fluid"
      breakpoints={{ '960px': '75vw', '641px': '90vw' }}
    >
      <div className="space-y-4 pt-2">
        <div className="field">
          <label className="block text-sm font-semibold text-gray-700 mb-1">Date *</label>
          <Calendar 
            value={holidayForm.date} 
            onChange={(e) => setHolidayForm({ ...holidayForm, date: e.value })} 
            showIcon 
            dateFormat="yy-mm-dd" 
            placeholder="Select holiday date"
            required 
            disabled={loading}
            className="w-full"
          />
        </div>

        <div className="field">
          <label className="block text-sm font-semibold text-gray-700 mb-1">Title *</label>
          <InputText 
            value={holidayForm.title} 
            onChange={(e) => setHolidayForm({ ...holidayForm, title: e.target.value })} 
            placeholder="E.g. Sankranthi Festival" 
            required 
            disabled={loading}
          />
        </div>

        <div className="field">
          <label className="block text-sm font-semibold text-gray-700 mb-1">Description</label>
          <InputTextarea 
            value={holidayForm.description} 
            onChange={(e) => setHolidayForm({ ...holidayForm, description: e.target.value })} 
            placeholder="Enter holiday description" 
            rows={3} 
            disabled={loading}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default HolidayDialog;
